<template>
  <span>
    <span v-html="ressource" v-if="ressource"></span>
    <span v-else-if="!hideIfEmpty">[{{ code }}]</span>
  </span>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: {
    code: {
      type: String,
      default: ""
    },
    hideIfEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["ressources"]),
    ressource() {
      let found = this.ressources.find((r) => r.code == this.code)
      if (found) {
        return found.valeur
      }
      return ""
    }
  }
}
</script>

<style>
</style>